import { Sparkles, Building2, Award, Globe } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

// Helper to format user name without duplicating title prefix
const formatUserName = (fullName) => {
  if (!fullName) return '';
  // Remove any existing title prefixes to avoid duplication
  const titlePrefixes = ['Dr.', 'Dr', 'Dra.', 'Dra', 'MD', 'DO', 'PhD', 'NP', 'PA', 'RN'];
  let cleanName = fullName.trim();
  for (const prefix of titlePrefixes) {
    if (cleanName.toLowerCase().startsWith(prefix.toLowerCase() + ' ')) {
      cleanName = cleanName.substring(prefix.length).trim();
      break;
    }
  }
  return cleanName;
};

const WelcomeStep = ({ user }) => (
  <div className="text-center space-y-6">
    <div className="flex justify-center">
      <div className="bg-gradient-to-br from-teal-100 to-teal-200 p-6 rounded-full">
        <Sparkles className="h-12 w-12 text-teal-600" />
      </div>
    </div>

    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">
        Welcome to MyMedMember! 🎉
      </h2>
      <p className="text-lg text-gray-600">
        {user?.full_name ? `Welcome, ${formatUserName(user.full_name)}!` : 'Welcome!'}
      </p>
      <p className="text-gray-600 mt-2">
        Let's get your clinic set up in just a few minutes. We'll guide you through the essential steps.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
      <Card className="border-2 border-teal-200 hover:border-teal-400 transition-colors">
        <CardContent className="pt-6 text-center">
          <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
            <Building2 className="h-6 w-6 text-teal-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">Complete Profile</h3>
          <p className="text-sm text-gray-600">
            Add your clinic information and branding
          </p>
        </CardContent>
      </Card>

      <Card className="border-2 border-purple-200 hover:border-purple-400 transition-colors">
        <CardContent className="pt-6 text-center">
          <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
            <Award className="h-6 w-6 text-purple-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">Create Plans</h3>
          <p className="text-sm text-gray-600">
            Set up membership plans with AI assistance
          </p>
        </CardContent>
      </Card>

      <Card className="border-2 border-blue-200 hover:border-blue-400 transition-colors">
        <CardContent className="pt-6 text-center">
          <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
            <Globe className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">WordPress Setup</h3>
          <p className="text-sm text-gray-600">
            Integrate with your website (optional)
          </p>
        </CardContent>
      </Card>
    </div>

    <div className="bg-teal-50 border border-teal-200 rounded-lg p-4 mt-6">
      <p className="text-sm text-teal-800">
        💡 <strong>Tip:</strong> You can skip this tour and access all settings later from your dashboard.
      </p>
    </div>
  </div>
);

export default WelcomeStep;
